<template>
    <div>
        <Language :add="add" v-model="form.lang" @change="handleLangChange"></Language>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="标题" prop="name">
                <el-input v-model="form.name" placeholder="请输入标题" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="seo关键词" prop="keyword">
                <DynamicTag v-model="keyword" @change="handleTagChange"></DynamicTag>
            </el-form-item>
            <el-form-item label="分类" prop="group_uuid">
                <FileCategory v-model="form.group_uuid" style="width: 300px"></FileCategory>
            </el-form-item>
            <el-form-item label="上传文件" prop="url">
                <Uploader type="all" v-model="form.url" @change="handleFileChange">选择上传文件</Uploader>
            </el-form-item>
            <el-form-item label="下载地址">
                <el-input :rows="3" type="textarea" readonly v-model="downloadUrl"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button style="width: 120px" @click="$router.back()">取消</el-button>
                <el-button style="width: 120px" type="primary" @click="handleConfirm">确定</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Language from "@/components/Language";
import DynamicTag from "@/components/DynamicTag";
import FileCategory from "@/components/FileCategory";
import Uploader from "@/components/Uploader";
import { add, edit, detail } from "@/api/file/list";
import { getUuid } from "@/jslibs/utils";
import { ossUrl } from "@/configs/oss";
export default {
    components: { Language, DynamicTag, FileCategory, Uploader },
    data() {
        return {
            ossUrl,
            form: {
                lang: "zh",
                name: "",
                keyword: "",
                group_uuid: "",
                url: "",
            },
            keyword: [],
            rules: {
                name: [{ required: true, message: "请输入标题" }],
                keyword: [{ required: true, message: "请输入seo关键词" }],
                group_uuid: [{ required: true, message: "请选择分类" }],
                url: [{ required: true, message: "请上传文件" }],
            },
            cuuid: "",
            isEdit: false,
            add: true,
        };
    },
    computed: {
        downloadUrl() {
            return this.form.url ? (this.form.url.indexOf("http") == -1 ? this.ossUrl + this.form.url : this.form.url) : "";
        },
    },
    mounted() {
        this.form.cuuid = this.$route.query.cuuid;
        if (this.form.cuuid) {
            this.add = false;
            this.isEdit = true;
            this.getDetail();
        } else {
            this.add = true;
            this.form.cuuid = getUuid();
        }
    },
    methods: {
        handleLangChange() {
            this.getDetail();
        },
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form = { ...result };
                        this.cuuid = result.cuuid;
                        this.form.keyword = result.keyword ? result.keyword.split(",") : [];
                        this.keyword = this.form.keyword;
                    } else {
                        this.form = { lang: this.form.lang, cuuid: this.form.cuuid };
                        this.cuuid = "";
                        this.$nextTick(() => {
                            this.$refs.form.clearValidate();
                        });
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleTagChange(value) {
            if (value && value.length > 0) {
                this.form.keyword = value;
            } else {
                this.form.keyword = "";
            }
        },
        handleFileChange(data) {
            const size = (data.size / (1024 * 1024)).toFixed(3) + "M";
            this.form.size = size;
            this.form.file_name = data.file_name;
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    keyword: this.form.keyword ? this.form.keyword.join() : "",
                };
                if (this.isEdit) {
                    if (this.cuuid) {
                        edit(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("修改成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    } else {
                        add(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("添加成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    }
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
